'use client';
import './Spinner.css';
import SlSpinner from '@shoelace-style/shoelace/dist/react/spinner/index.js';

const Spinner = () => {
	return <SlSpinner className='spinner' />;
};

export { Spinner };
